import ReportModel from './ReportModel.js' 
import store from 'store/store.js';
import Report from './Report.js'
import Vue from 'vue';
import Component from 'vue-class-component';

//let ReportModel = new ReportModel();

@Component
export default class ReportContainer extends Vue {
    constructor() {
        super();
        this.items = store.getters.currentDate; 
        this.setTimeTracking();
    }
    render(h) {
        return (
            <div>
                <Report container={this} items={this.items} />
            </div>
        );
    }
    mounted() {
        this.setTimeTracking();
    }
    /*Store Manipulate Methods*/
    setDate(date) {          
        ReportModel.setDate(date);
        this.setTimeTracking();
    }
    setTimeTracking() {
        let year = ReportModel.getDate()[1];
        let month = ReportModel.getDate()[2];
        ReportModel.getTimeTrackingTotal(month, year);
        ReportModel.setDebts()
    }
    setMonthDesc() {
        ReportModel.setMonthDesc();
        this.setTimeTracking();
        return ReportModel.getDate()[0];        
    }
    setMonthAsc() {
        ReportModel.setMonthAsc();
        this.setTimeTracking();
        return ReportModel.getDate()[0];
    } 
    /*Output Components*/
    getDebts() {
        let debts = store.getters.debts;

        if (debts != -1) {
            if (debts.must_punished) {
                
                let debtsInMinutes = debts.difference;
                
                let hour = parseInt(debtsInMinutes / 60, 10);
                let minute = debtsInMinutes - hour * 60;

                return "У вас задолженность " + hour + " " +this.getDebtTimeTitleWithTimeUnit("hour", hour) + " " + minute + " " + this.getDebtTimeTitleWithTimeUnit("minute", minute);
            }
        }
    }
    getDebtTimeTitleWithTimeUnit(timeUnit, number) {
    
        if (number <= 20) {
            return this.getTitleForTimeUnit(timeUnit, number);
        } else {
            var tail = number.toString();
            
            if (number > 20) {
                if (number < 100) {
                    tail = tail.substr(1);
                }
                tail = tail.substr(tail.length - 1);
            }
            return this.getTitleForTimeUnit(timeUnit, tail);
        }
    }
    getTitleForTimeUnit(timeUnit, number) {

        let timeTitles = {
            hour: ["часов", "час", "часа"],
            minute: ["минут", "минута", "минуты"]
        };
     
        let currentArray = timeTitles[timeUnit]
        var title = "";

        if (number < 10) {
            if (number == 0 || (number >= 5 && number <= 9)) {
                title = currentArray[0];
            } else if (number == 1) {
                title = currentArray[1];
            } else if (number >= 2 && number <= 4) {
                title = currentArray[2];
            }
        } else if (number >= 10 && number <= 20) {
            title = currentArray[0];
        }

        return title;
    }
    getTimeTracking(index) {
        let tt = store.getters.timeTracking;
        let buf = 0;
        if (tt != -1) {
            tt.forEach(element => {
                if (element.day == index) {
                    buf = element.count;
                }
            });
        }
        return buf;
    }
    getProjectWriteOff(index, proj) {
        let p = store.getters.projects;
        let buf = "";
        if (p != -1) {
            p.forEach(element => {
                if (proj == element.id) {
                    element.body.forEach(el => {
                        if (el.day == index) {
                            if(el.count!=0)
                                buf = el.count;
                        }
                    })
                }
            });
        }
        return buf;
    }
    getProject() {
        let p = store.getters.projects;
        let buf = [[" ", " "]];
        if (p != -1) {
            buf = [];
            let bufer = [];
            p.forEach(element => {
                buf.push({
                    id: element.id,
                    jira_id: element.jira_id,
                    title: element.title,
                    is_inside: element.is_inside
                });
            });
        }
        return buf;
    }
    getMonthTitle(){
        let month = ReportModel.getDate()[2];
        return ReportModel.getMonthTitleArray()[month];
    }
    getDayCount(){
        let year = ReportModel.getDate()[1];
        let month = ReportModel.getDate()[2];
        return ReportModel.getMonthNumberArray(year)[month];
    }
    getHolidayCell(d, m, y){
        let result = "";
        if (ReportModel.getHolidays(d, m, y) > -1 || this.getWeekDay(d) == "Сб" || this.getWeekDay(d) == "Вс"  ){
            result = "holiday-cell ";
        }
        if (d == new Date().getDate() && m == new Date().getMonth() && y == new Date().getFullYear()) {
            result = "current-day ";
        }
        return result;
    }
    getMonth() {
        return ReportModel.getDate()[2];
    }
    getYear() {
        return ReportModel.getDate()[1];
    }
    getWeekDay(index){
        let year = ReportModel.getDate()[1];
        let month = ReportModel.getDate()[2];
        return ReportModel.getWeekDay()[new Date(year, month, index).getDay()];
    }
    getTimeColorCell(index){
        if(index>=8){
            return "good-write-off";
        }
        if(index<8 && index!=0){
            return "bad-write-off"; 
        }
        return "";

    }
    getFullName(){
        return ReportModel.getFullName();
    }
}


// WEBPACK FOOTER //
// ./src/Report/ReportContainer.js